import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

interface TeaserDotProps extends SharedProps {
  flashing?: boolean
  forcePx?: boolean
}
/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-dot](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-dot)
 * - Storybook: [TeaserDot](https://designsystem.dn.se/?path=/docs/section-teaser-dot--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-dot/teaser-dot.scss'`
 *
 *
 * You can override size of the dot:
 * ```
 * .ds-teaser-dot {
 * // use css variable to optionally override size
 * --ds-teaser-dot-size: 10px;
 * }```
 */

export const TeaserDot = ({ flashing, forcePx, classNames, attributes = {} }: TeaserDotProps) => {
  const classes = formatClassString([
    'ds-teaser-dot',
    flashing && 'ds-teaser-dot--flashing',
    forcePx && 'ds-force-px',
    classNames,
  ])

  return <span className={classes} {...attributes}></span>
}
